import {ValueObject} from "../ValueObject";
// import {PipelineStage} from "../../../node.lib.mojo-base/hubspot/PipelineStage";

export interface IEvaluationCompleted {

  userEmail?: string;
  userUid: string;
  ticketStatus: string;
  when: number;
  whenAsString?: string;
}


export class EvaluationCompleted extends ValueObject<IEvaluationCompleted> {

  public static build( userUid: string, userEmail: string = null ): EvaluationCompleted {

    const value: IEvaluationCompleted = {
      userUid,
      // ticketStatus: PipelineStage.UNKOWN.label,
      ticketStatus: "UNKOWN",
      when: new Date().getTime()
    }

    if( userEmail ) {

      value.userEmail = userEmail;
    }

    return new EvaluationCompleted( value );
  }

  protected onSetValue(value: IEvaluationCompleted | null) {
  }



  public constructor( value: IEvaluationCompleted ) {

    super( value );
    if ( value ) {

      this.value = value;
    }
  }

}




